import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class BranchApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public get() {
    let endpoint = `branch-admin/users-branch`;
    const url = this.commonFunctionService.findApiUrl('branch-admin');

    return this.Api.get(endpoint, url);
  }
}
